import React from 'react';
import { Box, Text, Tooltip, SimpleGrid, HStack, Icon } from '@chakra-ui/react';
import {
    FaBoxes, FaClock, FaTruck, FaSearch, FaHourglassHalf,
} from 'react-icons/fa';

const StatTile = ({ bg, border, colorTitle, colorValue, title, value, footer, icon, iconColor, width = '100%' }) => (
    <Box
        bg={bg}
        p={{ base: 3, md: 4 }}
        borderRadius="md"
        boxShadow="sm"
        borderWidth={border ? '1px' : 0}
        borderColor={border || 'transparent'}
        width={width}
        minH={{ base: '92px', md: '104px' }}
        textAlign="center"
        display="flex"
        flexDirection="column"
        justifyContent="center"
        transition="box-shadow 0.15s, transform 0.15s"
        _hover={{ boxShadow: 'md', transform: 'translateY(-1px)' }}
    >
        <HStack justify="center" spacing={1.5}>
            {icon && <Icon as={icon} boxSize={{ base: 3, md: 3.5 }} color={iconColor || colorTitle} />}
            <Text fontSize={{ base: '10px', md: 'xs' }} fontWeight="bold" color={colorTitle} letterSpacing="wider" noOfLines={2}>
                {title}
            </Text>
        </HStack>
        <Text fontSize={{ base: 'lg', md: '2xl' }} fontWeight="extrabold" color={colorValue} mt={1} noOfLines={1} lineHeight="1.1">
            {value}
        </Text>
        {footer && (
            <Text fontSize={{ base: '10px', md: '11px' }} color={colorTitle} mt={0.5} noOfLines={1} fontWeight="medium">
                {footer}
            </Text>
        )}
    </Box>
);

const DevolucoesStatsPanel = ({ dados }) => {
    const totais = dados?.totais || {};

    return (
        <Box
            w="100%"
            mx="auto"
            mt={2}
            mb={3}
            border="1px solid #FF9F59"
            px={{ base: 2, md: 4 }}
            py={2}
            borderRadius="lg"
            boxShadow="md"
            bg="gray.50"
        >
            <Text
                fontSize="8px"
                textAlign="center"
                color="#F68633"
                fontWeight="bold"
                position="relative"
                top="-14px"
                bg="white"
                w="90px"
                px={1}
                borderRadius="lg"
                border="1px solid #FF9F59"
            >
                INFORMAÇÕES
            </Text>

            <Text fontSize="10px" color="gray.500" fontWeight="bold" mb={2} textAlign="center" letterSpacing="wider">
                VISÃO GERAL
            </Text>
            <SimpleGrid columns={{ base: 2, md: 3, lg: 5 }} spacing={3} mb={4}>
                <Tooltip label="Total de devoluções cadastradas no sistema." hasArrow>
                    <Box>
                        <StatTile
                            bg="orange.100"
                            colorTitle="orange.700"
                            colorValue="orange.900"
                            icon={FaBoxes}
                            title="TOTAL"
                            value={totais.total_registros ?? 0}
                        />
                    </Box>
                </Tooltip>
                <Tooltip label="Devoluções entregues que precisam ser revisadas hoje (inclui prazos de fim de semana ajustados para dia útil)." hasArrow>
                    <Box>
                        <StatTile
                            bg="red.100"
                            colorTitle="red.700"
                            colorValue="red.900"
                            icon={FaClock}
                            title="REVISÃO HOJE"
                            value={totais.total_urgentes ?? 0}
                            footer={(totais.total_atrasadas ?? 0) > 0 ? `⚠ ${totais.total_atrasadas} atrasada${totais.total_atrasadas === 1 ? '' : 's'}` : null}
                        />
                    </Box>
                </Tooltip>
                <Tooltip label="Pacotes de devolução em trânsito (aberta, enviada ou etiqueta gerada)." hasArrow>
                    <Box>
                        <StatTile
                            bg="blue.100"
                            colorTitle="blue.800"
                            colorValue="blue.900"
                            icon={FaTruck}
                            title="A CAMINHO"
                            value={totais.total_shipped ?? 0}
                        />
                    </Box>
                </Tooltip>
                <Tooltip label="Devoluções entregues ao vendedor aguardando revisão." hasArrow>
                    <Box>
                        <StatTile
                            bg="purple.100"
                            colorTitle="purple.700"
                            colorValue="purple.900"
                            icon={FaSearch}
                            title="EM REVISÃO"
                            value={totais.total_em_revisao ?? 0}
                        />
                    </Box>
                </Tooltip>
                <Tooltip label="Devoluções que ainda não foram encerradas." hasArrow>
                    <Box>
                        <StatTile
                            bg="gray.200"
                            colorTitle="gray.700"
                            colorValue="gray.900"
                            icon={FaHourglassHalf}
                            title="NÃO CONCLUÍDAS"
                            value={totais.total_nao_concluidas ?? 0}
                        />
                    </Box>
                </Tooltip>
            </SimpleGrid>

        </Box>
    );
};

export default DevolucoesStatsPanel;
